import styled from 'styled-components';

export const Container = styled.div`
	.profile-by-type-tab {
		margin-top: -33px;
	}

	.ds-content-container-tabs {
		height: calc(100vh - 246px);
	}
`;
